import session from "@/api/session";

export default {
  loadAllNumbers(supplier, pagi) {
    return session.get(`/voip/number-pool/numbers/?missing=false&limit=${pagi.limit}&page=${pagi.currentPage}&available=true&supplier=${supplier}`);
  },
  loadNumbers(val, type, supplier, pagi) {
    return session.get(`/voip/number-pool/numbers/?missing=false&limit=${pagi.limit}&page=${pagi.currentPage}&available=true&${type}=${val}&supplier=${supplier}`);
  },
  transferNumber(productId, data) {
    return session.post(`/voip/sites/${productId}/number-ranges/`,JSON.stringify(data));
  },
  loadNumberRanges(productId) {
    return session.get(`/voip/sites/${productId}/number-ranges/`);
  },
  updateNumberPorting(numberRangeId, data) {
    return session.patch(`/voip/number-ranges/${numberRangeId}/`,JSON.stringify(data));
  },
  getNumberPorting(numberRangeId, data) {
    return session.get(`/voip/number-ranges/${numberRangeId}/`,JSON.stringify(data));
  },
  addNumbers(productId, data) {
    return session.post(`/voip/sites/${productId}/numbers/`, JSON.stringify(data));
  },
  getNumbersInRange(numberRangeId) {
    return session.get(`/voip/number-ranges/${numberRangeId}/`);
  },
  createTransferOrder(numberRangeId) {
    return session.post(`/voip/number-ranges/${numberRangeId}/actions/create-transfer-order/`);
  },
  preAllocateNumber(pid,number) {
    return session.post(`/voip/sites/${pid}/numbers/actions/pre-allocate/`, JSON.stringify(number));
  },
  deleteNumber(id) {
    return session.delete(`/voip/numbers/${id}/`);
  },
  deletePortingNumber(id) {
    return session.delete(`/voip/number-ranges/${id}/`);
  },
  sendCustomerNumberReserveMail(pid) {
    return session.post(`/voip/sites/${pid}/numbers/actions/send-selection-email/`);
  },
  sendCloa(numberRangeId) {
    return session.post(`/voip/number-ranges/${numberRangeId}/actions/send-cloa/`);
  },
  loadNumberTransfers(options) {
    let order = '';
    if(options.sortDesc[0]!==undefined){ order = (options.sortDesc[0])?'desc':'asc'; }
    return session.get(`/voip/number-transfers/dashboard/?order=${order}&sort=${options.sortBy.join(",")}&page=${options.paginationPage}&limit=${options.paginationLimit}&status__in=${options.status.join(",")}&port_kind__in=${options.portKind.join(",")}&product_status__in=${options.productStatus.join(",")}&porting_status__in=${options.automatedOrderStatus.join(',')}`);
  },
  checkAddress(data) {
    return session.get(`/voip/number-transfers/address-check/?postcode=${data.post_code}&number=${data.number}`);
  },
  fetchEmailPreviewMismatch(numberTransferId) {
    return session.get(`/voip/number-transfers/${numberTransferId}/actions/preview-email-mismatch/`)
  },
  fetchEmailPreviewCancellation(numberTransferId) {
    return session.get(`/voip/number-transfers/${numberTransferId}/actions/preview-email-cancellation/`);
  },
  sendEmailPreviewMismatch(numberTransferId) {
    return session.post(`voip/number-transfers/${numberTransferId}/actions/send-email-mismatch/`)
  },
  
  sendEmailPreviewCancellation(numberTransferId) {
    return session.post(`/voip/number-transfers/${numberTransferId}/actions/send-email-cancellation/`);
  },

  translateNumberTo(nonGeoNumId,translateToId) {
    return session.patch(`/voip/numbers/${nonGeoNumId}/`,{translate_to_number_id:translateToId});
  },

  moveNumberToAnotherProduct({number_id, payload}) {
    return session.post(`/voip/numbers/${number_id}/actions/move/`, payload);
  }
};
